import { render, staticRenderFns } from "./ClientActivity.vue?vue&type=template&id=7a336b58&scoped=true&"
import script from "./ClientActivity.vue?vue&type=script&lang=js&"
export * from "./ClientActivity.vue?vue&type=script&lang=js&"
import style0 from "./ClientActivity.vue?vue&type=style&index=0&id=7a336b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a336b58",
  null
  
)

export default component.exports